import React from 'react';

import { Wrap, Logo, Link } from './styled';

const Header = () => (
    <Wrap>
        <Link href="/">
            <Logo />
        </Link>
    </Wrap>
);

export default Header;
